import PropTypes from 'prop-types';
import React from 'react';
import { SortableElement as sortableElement } from 'react-sortable-hoc';
import { Spinner } from 'components';
import userFavoritePropType from '../../../../propTypes/userFavoritePropType';

const SortableFavoriteItem = ({
  favorite,
  handleRemove,
  updatingFavorites,
}) =>
    <li className="favorites__body__container__card__item">
      {updatingFavorites ?
        <Spinner /> :
        favorite.name
      }
      <div className="favorites__body__container__card__item__controls">
        <a
          className="favorites__body__container__card__item__controls__delete"
          onClick={evt => handleRemove(evt, favorite)}
          onTouchEnd={evt => handleRemove(evt, favorite)}
        >
          Remove
        </a>
        <a className="favorites__body__container__card__item__controls__move" />
      </div>
    </li>;

SortableFavoriteItem.propTypes = {
  favorite: userFavoritePropType,
  handleRemove: PropTypes.func,
  updatingFavorites: PropTypes.bool,
  styles: PropTypes.object,
};

export default sortableElement(SortableFavoriteItem);
